import { CommentOutlined } from '@ant-design/icons'
import React from 'react'

export default function NoteSection() {
    return (
        <div style={{
            border: '1px solid #e2e4e9',
            borderRadius: 6,
            marginBottom: 16
        }}>
            <div
                style={{
                    borderBottom: '1px solid #e2e4e9',
                    padding: 8,
                    background: '#f0f2f44d',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                }}
            >
                <CommentOutlined />
                <span style={{
                    fontWeight: 600,
                    fontFamily: 'tradeGothic',
                    fontSize: 14
                }}>
                    Notes
                </span>
            </div>
            <div style={{padding: 8}}>
                All notes from both profiles are merged into one unified list on the surviving profile.
            </div>
        </div>
    )
}
